import { load } from "@cashfreepayments/cashfree-js";
const CASHFREE_MODE = process.env.NEXT_PUBLIC_NEXT_CASHFREE_MODE;

const cashfree = await load({
  mode: CASHFREE_MODE,
});


export default cashfree;
